
    import * as React from 'react';

    const ShippingAlt20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Shipping_Alt_20_svg__Icons/Shipping-Box/20" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M10,4 L19,7 L19,14 L10,17 L1,14 L1,7 L10,4 Z M2,8.38742589 L2,13.2792408 L9.5,15.778 L9.5,10.887 L2,8.38742589 Z M18,8.38742589 L10.5,10.887 L10.5,15.778 L18,13.2792408 L18,8.38742589 Z M14.357,6.506 L7.127,9.042 L10,10 L17.42,7.527 L14.357,6.506 Z M10,5.05409255 L2.58,7.527 L5.665,8.555 L12.895,6.019 L10,5.05409255 Z" id="Shipping_Alt_20_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    ShippingAlt20.displayName = 'ShippingAlt20';

    export default ShippingAlt20;
  